/**
 * @Description 选址地图详情抽屉
 */

import { FC, useState, useEffect, useMemo, useRef } from 'react';
import { useMethods } from '@lhb/hook';
import { useUnactivate } from 'react-activation';
import styles from './index.module.less';
import V2Container from '@/common/components/Data/V2Container';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import Top from './components/Top';
import Main from './components/Main';
import SkeletonMapDetail from '@/common/components/Skeleton/SkeletonMapDetail';
import { spotEvaluationDetail, spotEvaluationOverview } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '../../ts-config';
import { getSelectionMapButton } from '@/common/api/siteselectionmap';
import { SemirModelCode } from '@/views/youth/pages/map/ts-config';
// import { useSelector } from 'react-redux';

const AreaDetailDrawer: FC<any> = ({
  drawerData,
  setDrawerData,
}) => {
  // const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const [isSemirModel, setIsSemirModel] = useState<boolean>(false); // 是否是森马模型

  const openTimeRef: any = useRef<any>(0);
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [overViewData, setOverViewData] = useState<any>({}); // 概览卡片
  const [loading, setLoading] = useState<boolean>(false); // 加载中
  const [configSwitch, setConfigSwitch] = useState<any>({});
  // 是否是森马租户
  // const isSemir = useMemo(() => {
  //   const { isSenma } = tenantCheckData || {};
  //   return !!isSenma;
  // }, [tenantCheckData]);

  useEffect(() => {
    const { open, lng, lat } = drawerData;
    if (open && lng && lat) {
      // methods.eventTracking();
      methods.getDetail();
    }
    // 关闭弹窗时，将详情数据重置
    if (!open) {
      setDetail({});
    }
  }, [drawerData]);

  // 是否是商场类型
  const isMallType = useMemo(() => {
    const { resourceMallFlag } = detail || {};
    return !!resourceMallFlag;
  }, [detail]);
  // 选址地图页被缓存,离开当前页面时，关闭抽屉
  useUnactivate(() => {
    methods.onCloseDrawer();
  });

  // methods
  const methods = useMethods({
    getDetail: async () => { // 获取商圈详情
      setLoading(true);
      const { lng, lat, poiName, type, modelClusterId, modelConfigId, radius } = drawerData;
      const params: any = {
        type,
        modelConfigId,
      };
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.lng = lng;
        params.lat = lat;
        params.radius = radius;
      }
      if (poiName) {
        params.poiName = poiName;
      }
      // const detailParams: any = {
      //   lng,
      //   lat,
      //   cityName,
      //   type,
      //   modelClusterId,
      //   modelConfigId
      // };
      // if (drawerData?.poiName) { // poi点位名称，兼容搜索地址时，高德返回的形成和服务端接口查询poi的名字不同时的字段
      //   detailParams.poiName = drawerData.poiName;
      // }
      Promise.all([
        spotEvaluationDetail(params),
        // spotEvaluationOverview(params),
        getSelectionMapButton({ modelConfigId })
      ])
        .then(([detailRes, configRes]) => {
          setDetail(detailRes);
          // setOverViewData(overviewRes);
          setConfigSwitch({
            ...configRes
          });
        })
        .catch((error) => {
          console.error('Error fetching details:', error);
        })
        .finally(() => {
          setLoading(false);
        });

      spotEvaluationOverview(params).then((res: any) => {
        const { modelConfigCode } = res || {};
        setIsSemirModel(modelConfigCode === SemirModelCode);
        setOverViewData(res);
      });
    },
    // 当前为选址地图埋点，需替换
    eventTracking: (isOpen = true) => { // 埋点
      if (isOpen) {
        openTimeRef.current = new Date().getTime();
        return;
      }
      // 关闭的时候上报总时长
      const curTimestamp = new Date().getTime();
      const timeLag = curTimestamp - openTimeRef.current; // 停留时长
      if (openTimeRef.current && curTimestamp && timeLag > 0) {
        window.LHBbigdata.send({
          event_id: 'dcf71805-ed9e-a3e9-1c09-85daf0d49e02', // 事件id
          msg: {
            viewTimestamp: timeLag
          }
        });
        openTimeRef.current = 0;
      }
    },
    onCloseDrawer() {
      setDrawerData({
        open: false,
        cityId: '',
        cityName: '',
        lng: '',
        lat: '',
        type: '',
        modelClusterId: '',
        modelConfigId: ''
      });
    },
  });

  return (
    <V2Drawer
      bodyStyle={{
        padding: 0,
        paddingBottom: 16
      }}
      open={drawerData.open}
      destroyOnClose
      onClose={methods.onCloseDrawer}
      contentWrapperStyle={{
        width: '90%',
        minWidth: '921px', // 1024*0.9
        maxWidth: 'auto',
      }}
      className={styles.areaDetailDrawer}
    >
      {loading
        ? <SkeletonMapDetail/>
        : <V2Container
          // 容器上下padding 0， 所以减去就是0
          style={{ height: '100vh' }}
          extraContent={{
            top: <Top
              detail={detail}
              drawerData={drawerData}
              tenantId={drawerData.tenantId}
              configSwitch={configSwitch}
              // isSemirModel={isSemirModel}
            />,
          }}
        >
          <Main
            drawerData={drawerData}
            detail={detail}
            overViewData={overViewData}
            isMallType={isMallType}
            configSwitch={configSwitch}
            tenantId={drawerData.tenantId}
            isSemirModel={isSemirModel}
          />
        </V2Container>
      }
    </V2Drawer>
  );
};

export default AreaDetailDrawer;

